import { AppLauncherConfig, FnNext, OpenContext } from '../types';
import { createWechatLaunchStrategy } from '../strategy/wechat';
import { createQQLaunchStrategy } from '../strategy/qq';
import { Launcher } from '../util/launcher';
import { IS_IOS, IS_ANDROID, IS_WEISHI } from '../util/ua';

export const WEI_SHI_CONFIG: AppLauncherConfig = {
  model: {
    /** 默认渠道号 */
    confid: '514',
  },
  intent: {
    package: 'com.tencent.weishi',
  },
  scheme: {
    protocol: 'weishi',
  },
  fallback() {
    if (IS_IOS) {
      return 'https://itunes.apple.com/cn/app/id691828408';
    } if (IS_ANDROID) {
      return 'DOWNLOAD:https://weseeugg.qq.com/download?channelid=210010139';
    }
    return 'DOWNLOAD:https://weseeugg.qq.com/download?channelid=210010139';
  },
  customLaunch: [
    /**
     * 在App内的话直接拉起就好了
     */
    function inAppStrategy(context: OpenContext, launcher: Launcher, next: FnNext): Promise<boolean> {
      if (IS_WEISHI) {
        return launcher.launchByLocation(context.schemeUrl);
      }
      return next();
    },
    createWechatLaunchStrategy({
      packageName: 'com.tencent.weishi',
      packageUrl: 'weishi://',
      appID: 'wx5dfbe0a95623607b',
      downloader: {
        developer: '腾讯公司',
        icon: 'http://puui.qpic.cn/media_img/0/promotion1561031897/0',
        name: '微视',
        getAppVersion: () => '',
        permissionUrl: '',
        privacyAgreementUrl: '',
      },
    }),
    createQQLaunchStrategy({
      packageName: 'com.tencent.weishi',
      packageUrl: 'weishi://',
      downloader: {
        appid: '',
        via: 'ANDROID.WEISHI',
        getConfid: context => context.model.confid as string ?? '',
      },
    }),
  ],
};
